import type { LanguageKey } from "@packages/core/language/language.ts";
import type { InitOptions } from "i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export function createI18nextInstance(language: LanguageKey, options: InitOptions = {}) {
    // oxlint-disable-next-line import/no-named-as-default-member
    const instance = i18n.createInstance().use(initReactI18next);

    void instance.init({
        lng: language,
        ...options,
        interpolation: {
            escapeValue: false,
            ...options.interpolation
        }
    });

    return instance;
}
